import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as UserManagementActions from './users.actions';
import IUserManagementState from './users.state';
import { ITerminalUser } from 'src/app/features/settings/models/user.model';

export const usersStateKey = 'users';

export const adapter: EntityAdapter<ITerminalUser> =
  createEntityAdapter<ITerminalUser>();

export const usersInitialState: IUserManagementState = adapter.getInitialState({
  // additional entity state properties
  loadingUsers: false,
  loadingUsersError: '',
});

const reducer = createReducer(
  usersInitialState,
  on(
    UserManagementActions.LoadUsersAction,
    (state: IUserManagementState): IUserManagementState => ({
      ...state,
      loadingUsers: true,
    }),
  ),
  on(
    UserManagementActions.StoreUsersAction,
    (state: IUserManagementState, { users }) =>
      adapter.setAll(users, { ...state, loadingUsers: false }),
  ),
  on(
    UserManagementActions.LoadUsersErrorAction,
    (state: IUserManagementState, { error }): IUserManagementState => ({
      ...state,
      loadingUsers: false,
      loadingUsersError: error,
    }),
  ),
  on(
    UserManagementActions.UpdateUserAction,
    (state: IUserManagementState, { user }) => adapter.upsertOne(user, state),
  ),
  on(
    UserManagementActions.UpdateUserSuccessAction,
    (state: IUserManagementState, { user }) => adapter.upsertOne(user, state),
  ),
  on(
    UserManagementActions.AddUserSuccessAction,
    (state: IUserManagementState, { user }) => adapter.upsertOne(user, state),
  ),
  on(
    UserManagementActions.ResendUserInviteSuccessAction,
    (state: IUserManagementState, { user }) => adapter.upsertOne(user, state),
  ),
  on(
    UserManagementActions.DeactivateUserSuccessAction,
    (state: IUserManagementState, { user }) => adapter.upsertOne(user, state),
  ),
);

export const UserManagementReducer = (
  state: IUserManagementState | undefined,
  action: Action,
) => reducer(state, action);
